import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import debug from 'debug';
import superjson from 'superjson';
import { isDesktop } from '@/const/version';
import type { LambdaRouter } from '@/server/routers/lambda';

import { ErrorResponse } from './types';

const log = debug('lobe-image:lambda-client');

const links = [
  httpBatchLink({
    fetch: async (input, init) => {
      if (isDesktop) {
        const { desktopRemoteRPCFetch } = await import('./helpers/desktop-remote-rpc-fetch');

        const res = await desktopRemoteRPCFetch(input as string, init);

        if (res) return res;
      }

      const response = await fetch(input, init);

      if (response.ok) return response;

      const errorRes: ErrorResponse = await response.clone().json();

      const { loginRequired } = await import('@/components/error/login-required-notification');
      const { fetchErrorNotification } = await import('@/components/error/fetch-error-notification');

      errorRes.forEach(item => {
        const errorData = item.error.json;
        const status = errorData.data.httpStatus;

        switch (status) {
          case 401: {
            loginRequired.redirect();
            break;
          }
          default: {
            fetchErrorNotification.error({ errorMessage: errorData.message, status });
          }
        }
      });

      return response;
    },
    headers: async () => {
      // dynamic import to avoid circular dependency

      // TODO: we need to support provider select for chat page
      const headers = {};
      log('Headers: %O', headers);
      return headers;
    },
    maxURLLength: 2083,
    transformer: superjson,
    url: '/api/trpc/lambda',
  }),
];

export const lambdaClient = createTRPCClient<LambdaRouter>({
  links,
});

export const lambdaQuery = createTRPCReact<LambdaRouter>();

export const lambdaQueryClient = lambdaQuery.createClient({ links });
